module.exports = __webpack_public_path__ + "88883d19d2b4922e2d6d027377a8353a.fbx";